<script lang="ts">
  import { page } from '$app/state';
  import InfiniteScroll from '$lib/components/common/InfiniteScroll.svelte';
  import { goto } from '$app/navigation';
  import { listCourses } from '$lib/api/courses';
  import TableError from '$lib/components/TableError.svelte';
  import TableMessage from '$lib/components/TableMessage.svelte';

  let searchParam = $state(page.url.searchParams.get('search') ?? '');
  let searchTextBox = $state(page.url.searchParams.get('search') ?? '');

  function updateSearch(searchStr: string) {
    searchParam = searchStr.toLowerCase();
  }
</script>

<div class="d-flex mb-3 align-items-center">
  <h2 class="mb-0 flex-grow-1">Courses</h2>
  <a href="./courses/new" class="btn btn-primary">New Course</a>
</div>
<div>
  <label for="search" class="visually-hidden">Search courses</label>
  <input
    class="form-control mb-3"
    bind:value={searchTextBox}
    autocomplete="off"
    id="search"
    type="search"
    placeholder="Search courses by course ID or course name"
    oninput={e => updateSearch(e.currentTarget.value)}
  />
</div>
<InfiniteScroll loadData={listCourses} queryString={searchParam} minimumQueryStringLength={0}>
  {#snippet dataRenderer(courses, query, shouldShowLoadingIndicator, error, loadingIndicator)}
    <table class="table table-borderless table-hover mt-3">
      <thead>
        <tr class="border-bottom">
          <th scope="col">Course ID</th>
          <th scope="col">Course Name</th>
          <th scope="col" class="text-end">Skill Categories</th>
          <th scope="col" class="text-end">Skills</th>
        </tr>
      </thead>
      <tbody>
        {#each courses as course (course.id)}
          <tr onclick={() => goto(`/admin/courses/${course.id}`)}>
            <td>{course.code}</td>
            <td><a href="/admin/courses/{course.id}">{course.name}</a></td>
            <td class="text-end">{course.skillCategoryCount}</td>
            <td class="text-end">{course.skillCount}</td>
          </tr>
        {/each}
      </tbody>
    </table>

    {#if error}
      <TableError {error} />
    {:else if shouldShowLoadingIndicator}
      {@render loadingIndicator()}
    {:else if courses.length === 0}
      <TableMessage message="No courses found!" />
    {/if}
  {/snippet}
  {#snippet loadingIndicator()}
    <TableMessage message="Loading..." />
  {/snippet}
</InfiniteScroll>

<style>
  .table > tbody > tr > * {
    cursor: pointer;
  }
</style>
